import { useAppSelector } from 'app/hooks';
import { getIsEditor } from 'app/slices/UserSlice';
import React from 'react';
import EditButton from '../editbutton/EditButton';
import StandingsButton from '../standingsbutton/StandingsButton';
import styles from './ControlButtons.module.scss';

type ControlButtonsProps = {
  className?: string;
  onEdit?: () => void;
  onShowDivStandings?: () => void;
  showingDivStandings?: boolean;
};

const ControlButtons: React.FC<ControlButtonsProps> = ({
  className = '',
  onEdit = () => undefined,
  onShowDivStandings = () => undefined,
  showingDivStandings = false,
}) => {
  const baseCls = `${styles.ControlButtonsContainer} ${className}`;

  const isEditor = useAppSelector(getIsEditor);

  return (
    <div className={baseCls}>
      <StandingsButton selected={showingDivStandings} onShowStandings={onShowDivStandings} />
      {isEditor && <EditButton onEdit={onEdit} />}
    </div>
  );
};

export default ControlButtons;
